type WorkSessionEvent = "saved";

type Listener = () => void;

class WorkSessionEventBus {
  private listeners: Record<WorkSessionEvent, Set<Listener>> = {
    saved: new Set(),
  };

  emit(event: WorkSessionEvent) {
    this.listeners[event].forEach((listener) => listener());
  }

  on(event: WorkSessionEvent, listener: Listener) {
    this.listeners[event].add(listener);

    return () => {
      this.listeners[event].delete(listener);
    };
  }
}

export const workSessionEvents = new WorkSessionEventBus();
